import './images-carousel.scss';

jQuery(document).ready(function(){

  // Slick Slider
  jQuery('.paragraph--images-gallery').each( function() {

    var galleryId = jQuery(this).data('id');
    var galleryPager = jQuery(this).find('.pig__paging');

    jQuery(this).find('.pig__slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: 0,
      centerMode: true,
      fade: true,
      arrows: true,
      dots: false,
      dotsClass: 'pig__paging',
      asNavFor: '#images-gallery-nav-' + galleryId,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            arrows: false,
            dotsClass: 'slick-dots'
          }
        }
      ]
    });

    jQuery(this).find('.pig__navigation').slick({
      slidesToShow: 10,
      slidesToScroll: 1,
      asNavFor: '#images-gallery-' + galleryId,
      dots: false,
      focusOnSelect: true
    });

    jQuery(this).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      galleryPager.text(i + '/' + slick.slideCount);
    });
  });
});
